import { useEffect, useRef } from "react";

export default function CursorGlow() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (window.matchMedia("(pointer: coarse)").matches) {
      el.style.display = "none";
      return;
    }
    let tx = window.innerWidth / 2;
    let ty = window.innerHeight / 3;
    let x = tx;
    let y = ty;
    let raf;

    const move = (e) => {
      tx = e.clientX;
      ty = e.clientY;
      el.style.opacity = "0.7";
    };

    window.addEventListener("mousemove", move, { passive: true });

    const loop = () => {
      x += (tx - x) * 0.08;
      y += (ty - y) * 0.08;
      el.style.transform = `translate3d(${x - 280}px, ${y - 280}px, 0)`;
      raf = requestAnimationFrame(loop);
    };
    loop();

    return () => {
      window.removeEventListener("mousemove", move);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      data-testid="cursor-glow"
      className="pointer-events-none fixed top-0 left-0 z-30 h-[560px] w-[560px] rounded-full opacity-0 mix-blend-screen transition-opacity duration-700"
      style={{
        background:
          "radial-gradient(closest-side, rgba(59,130,246,0.16), rgba(139,92,246,0.07) 45%, transparent 70%)",
      }}
    />
  );
}
